import axios from "axios";

// zawgyi-unicode converter
const Rabbit = require("rabbit-node");

// --------------------------------------
//              ACTION TYPES
// --------------------------------------
export const NEWS_GET_START = "NEWS_GET_START";
export const NEWS_GET_SUCCESS = "NEWS_GET_SUCCESS";
export const NEWS_GET_FAIL = "NEWS_GET_FAIL";

export const NEWS_ADD_COMMENT = "NEWS_ADD_COMMENT";
export const NEWS_ADD_CHILD_COMMENT = "NEWS_ADD_CHILD_COMMENT";
export const NEWS_DELETE_COMMENT = "NEWS_DELETE_COMMENT";

export const ADD_NEWS_FROM_NOTIFICATION = "ADD_NEWS_FROM_NOTIFICATION";
// --------------------------------------
//            ACTION CREATORS
// --------------------------------------

// GET:
export const getNewsStart = () => {
  return {
    type: NEWS_GET_START,
  };
};

export const getNewsSuccess = (news) => {
  return {
    type: NEWS_GET_SUCCESS,
    news: news,
  };
};

export const getNewsFail = (error) => {
  return {
    type: NEWS_GET_FAIL,
    error: error,
  };
};

// Infinite scroll/paginated news fetcher
export const getNews = ({ page = 1, append = false, country, search } = {}) => {
  return (dispatch, getState) => {
    if (!append) dispatch(getNewsStart());
    const language = getState().i18nState.lang;
    const sort = getState().FiltersSortersState.sort.news;
    let url = `${process.env.REACT_APP_API_V2_URL}/news/?lang=${language}&page=${page}`;
    if (country && country !== 0) url += `&country=${country}`;
    if (search && search.trim()) url += `&search=${encodeURIComponent(search)}`;
    if (sort) url += `&sort=${encodeURIComponent(sort)}`;

    return axios
      .get(url)
      .then((res) => {
        let news = res.data.results || [];
        if (language === "mm-z") {
          news = news.map((item) => ({ ...item, title_mm_uni: Rabbit.zg2uni(item.title) }));
        }
        dispatch(getNewsSuccess({ news, append, next: res.data.next, count: res.data.count }));
        return news;
      })
      .catch((err) => {
        dispatch(getNewsFail(err));
        throw err;
      });
  };
};

// ADD:
export const addNewsFromNotification = (news) => {
  return {
    type: ADD_NEWS_FROM_NOTIFICATION,
    news: news,
  };
};

export const addNewsComment = (comment) => {
  return {
    type: NEWS_ADD_COMMENT,
    comment: comment,
  };
};

export const addNewsChildComment = (comment) => {
  return {
    type: NEWS_ADD_CHILD_COMMENT,
    comment: comment,
  };
};

// DELETE:
export const deleteNewsComment = (news_id, comment_id) => {
  console.log(`RECEIVED NEWS ID: ${news_id}, NEWS ID: ${comment_id}`);
  return {
    type: NEWS_DELETE_COMMENT,
    news_id: news_id,
    comment_id: comment_id,
  };
};
